import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';

class DraftItemAssetsListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      itemId: null,
      assets: [],
    });
  }

  handleItemAssetUploadPercentageChange = action((field, percentage) => {
    this.assets = this.assets.map((asset) => {
      return {
        ...asset,
        ...(asset.field === field && { uploadPercentage: percentage }),
      };
    });
  });

  init = action((item) => {
    this.itemId = item.id;

    this.assets = (item.type.requiredAssetsTypes || []).reduce((acc, asset) => {
      const source = asset.indexOf('ANSWER') > -1 ? 'ANSWER' : 'ITEM';
      const type = asset.split('_').pop();

      if (source === 'ANSWER') {
        return [
          ...acc,
          ...item.answers
            .map((answer, index) => ({ ...answer, index }))
            .filter((answer) => asset.indexOf('ONLY_CORRECT') < 0 || answer.correct)
            .map((answer) => ({
              type,
              location: 'Answer',
              text: answer.text,
              field: `answers[${answer.index}].${
                {
                  ONLY_CORRECT_ANSWER_AUDIO: 'audio',
                  ONLY_CORRECT_ANSWER_IMAGE: 'image',
                  ALL_ANSWERS_IMAGE: 'image',
                  ALL_ANSWERS_AUDIO: 'audio',
                }[asset]
              }`,
            })),
        ];
      }

      return [
        ...acc,
        {
          type,
          value:
            item[
              {
                ITEM_AUDIO: 'audio',
                ITEM_TITLE_AUDIO: 'image',
                ITEM_POST_PHRASE_AUDIO: 'postPhraseAudio',
                ITEM_POST_PHRASE_IMAGE: 'postPhraseImage',
                ITEM_IMAGE: 'image',
                ITEM_VIDEO: 'videoLink',
              }[asset]
            ],
          field: {
            ITEM_AUDIO: 'audio',
            ITEM_TITLE_AUDIO: 'image',
            ITEM_POST_PHRASE_AUDIO: 'postPhraseAudio',
            ITEM_POST_PHRASE_IMAGE: 'postPhraseImage',
            ITEM_IMAGE: 'image',
            ITEM_VIDEO: 'video',
          }[asset],
          location: {
            ITEM_AUDIO: 'Item Text',
            ITEM_TITLE_AUDIO: 'Item Title',
            ITEM_POST_PHRASE_AUDIO: 'Item Post Phrase',
            ITEM_POST_PHRASE_IMAGE: 'Item Post Phrase',
            ITEM_IMAGE: 'Item Image',
            ITEM_VIDEO: 'Item Video',
          }[asset],
          text: {
            ITEM_AUDIO: item.text,
            ITEM_IMAGE: item.text,
            ITEM_TITLE_AUDIO: item.title,
            ITEM_POST_PHRASE_AUDIO: item.postPhrase,
            ITEM_POST_PHRASE_IMAGE: item.postPhrase,
          }[asset],
        },
      ];
    }, []);
  });
}

export default DraftItemAssetsListService;
